module.exports = __webpack_public_path__ + "static/media/img6.7f164f3e.jpg";